import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Icon,
  Modal,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class PaymentRequest extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
  }

  constructor(props) {
    super(props);
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 521;

    this.state = {
      isMobile,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }

  handleOnClose = (e) => {
    this.props.onClose(e);
  }

  handleOnConfirm = (e) => {
    this.props.onConfirm(e);
  }

  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 521;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }

  render() {
    const { isMobile } = this.state;
    const { t } = this.props;
    return (
      <Modal
        size={isMobile ? 'small' : 'tiny'}
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Modal.Content>
          <Modal.Description>
            <Grid centered>
              <Grid.Row>
                <Grid.Column mobile={2} tablet={2} computer={2} textAlign="right" verticalAlign="middle">
                  <Icon name="info circle" color="green" size="big" inverted />
                </Grid.Column>
                <Grid.Column mobile={14} tablet={14} computer={14} textAlign="left">
                  <Trans ns={TRANSLATION_FILES.screens}>
                    Payment Request link will be sent via SMS and Email to Purchaser. <br />
                    Link will expire in 24 hours if no payment made.
                  </Trans>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={this.handleOnClose} content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
          <Button color="green" onClick={this.handleOnConfirm} content={t('Confirm', { ns: TRANSLATION_FILES.translation })} />
        </Modal.Actions>
      </Modal>
    );
  }
}
export default withTranslation(namespaces)(PaymentRequest);



// WEBPACK FOOTER //
// ./src/containers/modals/PaymentRequest.jsx